import { useState } from 'react';
import { ToBracketedCommaList } from '../../lib/helpers/StringHelper';
import AlertWithIcon from '../AlertWithIcon';
import { CsvRawDataRowSanitiserSummary } from './CsvRawDataRowSanitiser';
import { P2GBox, P2GText, P2GLink } from '@parcel2go/core-ui';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
interface props {
  summary: CsvRawDataRowSanitiserSummary;
}

const CsvErrorRow: React.FC<{ title: string; indexes: number[] }> = (props) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  return (
    <P2GBox>
      <P2GText>{props.title}</P2GText>{' '}
      {props.indexes.length < 50 && (
        <>
          <P2GLink onClick={() => setShow(!show)}>
            {show ? t('HIDE_BUTTON', { defaultValue: 'Hide' }) : t('SHOW_BUTTON', { defaultValue: 'Show' })}
          </P2GLink>
          {show && (
            <P2GBox>
              <Trans
                i18nKey="CSV_ROW_ERROR_ROWS"
                t={t}
                values={{ indexes: ToBracketedCommaList(props.indexes.map((x) => x.toString())) }}
                defaults="Rows: {{indexes}}"
              />
            </P2GBox>
          )}
        </>
      )}
    </P2GBox>
  );
};

export const CsvUploadSummary: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  if (!props.summary || props.summary.errors <= 0) {
    return null;
  }

  return (
    <AlertWithIcon color="warning">
      <P2GText component="p">
        {t('FILE_ERROR_ALERT', { defaultValue: 'There were some issues with your file.' })}
      </P2GText>
      <P2GBox mt={2} mb={2}>
        {props.summary.blankColumns.length > 0 && (
          <CsvErrorRow
            title={
              props.summary.blankColumns.length == 1
                ? t('CSV_ROW_IS_BLANK_ERROR', { defaultValue: '1 row is blank' })
                : t('CSV_ROW_IS_BLANK_ERROR_ALTERNATIVE', {
                    defaultValue: '{{blankColumns}} rows are blank',
                    blankColumns: props.summary.blankColumns.length
                  })
            }
            indexes={props.summary.blankColumns}
          />
        )}
        {props.summary.incorrectColumns.length > 0 && (
          <CsvErrorRow
            title={
              props.summary.incorrectColumns.length == 1
                ? t('CSV_ROW_ERROR_TITLE', {
                    defaultValue: "1 row doesn't have the same number of columns as the header ({{count}})",
                    count: props.summary.headerColumnCount
                  })
                : t('CSV_ROW_ERROR_TITLE_ALTERNATIVE', {
                    defaultValue:
                      "{{incorrectColumns}} rows don't have the same number of columns as the header ({{headerColumnCount}})",
                    headerColumnCount: props.summary.headerColumnCount,
                    incorrectColumns: props.summary.incorrectColumns.length
                  })
            }
            indexes={props.summary.incorrectColumns}
          />
        )}
      </P2GBox>
      <P2GText component="p">
        <strong>{t('ITEMS_NOT_INCLUDED', { defaultValue: 'These items have not been included.' })}</strong>
      </P2GText>
    </AlertWithIcon>
  );
};
